export default "__VITE_ASSET__CbQzYoHL__"